import React from 'react';
import HomeImage from '../../../assets/Images/homepage4.png';
import './Hero.css';

export default function Hero() {
  return (
    <section className="home-hero-section">
      <div className="home-hero-bg">
        <img
          src={HomeImage}
          alt="Haatza Seller Banner"
          className="home-hero-img"
        />

        {/* Statistics Overlay Card */}
        <div className="hero-stats-card">
          <div className="hero-stat-item">
            <span className="hero-stat-number">10 Lakh+</span>
            <span className="hero-stat-desc">Seller community</span>
          </div>
          <div className="hero-stat-divider" />
          <div className="hero-stat-item">
            <span className="hero-stat-number">24×7</span>
            <span className="hero-stat-desc">Online Business</span>
          </div>
          <div className="hero-stat-divider" />
          <div className="hero-stat-item">
            <span className="hero-stat-number">7</span>
            <span className="hero-stat-desc">days* payment</span>
          </div>
          <div className="hero-stat-divider" />
          <div className="hero-stat-item">
            <span className="hero-stat-number">19000+</span>
            <span className="hero-stat-desc">Pincodes served</span>
          </div>
        </div>
      </div>
    </section>
  );
}
